import { Card, CardBody } from "@progress/kendo-react-layout";
import { useAppSelector } from "../../../app/hooks";
import { getLastToolRequest, isCommercialSimulatorToolRequest } from "../../../models/toolRequestModels";
import { getToolResponseById, type CommercialSimulatorToolResponse } from "../../../models/toolResponseModels";
import { selectMessages } from "../../../slices/chatSlice";

const renderEmpty = () => {
    return <>No Data Available</>;
};

const SimulationInputs: React.FC = () => {
    const chatMessages = useAppSelector(selectMessages);
    const latestToolRequest = getLastToolRequest(chatMessages);
    if (!isCommercialSimulatorToolRequest(latestToolRequest?.payload)) {
        return renderEmpty();
    }
    const latestToolResponse = getToolResponseById<CommercialSimulatorToolResponse>(chatMessages, latestToolRequest.payload.id);
    if (!latestToolResponse) {
        return renderEmpty();
    }

    const brand = "NA";
    const retailer = latestToolResponse.tool_call_user_selection.retailer_name;
    const sku = latestToolResponse.tool_call_user_selection.sku_name;
    const period = latestToolRequest.payload.input?.plan_time_period_info;
    const retailerWeeks = "NA";
    const totalBudget = latestToolRequest.payload.input?.plan_budget;

    return (
        <Card className="shadow-sm">
            <CardBody className="p-0">
                <div className="px-3 px-lg-4 pt-3 pb-2 border-bottom">
                    <div className="d-flex align-items-start gap-2">
                        <span
                            className="bg-success rounded-pill mt-1"
                            style={{ width: "4px", minHeight: "20px" }}
                            aria-hidden="true"
                        />
                        <div>
                            <h2 className="h4 mb-1">Simulation Inputs</h2>
                            <p className="text-muted mb-0">Define your commercial scenario</p>
                        </div>
                    </div>
                </div>

                <div className="px-3 px-lg-4 py-3">
                    <h3 className="h6 mb-3">Inputs</h3>

                    <div className="row g-3">
                        <div className="col-12 col-lg-6">
                            <div className="mb-3">
                                <div className="small text-muted">Brand</div>
                                <div>{brand}</div>
                            </div>
                            <div className="mb-3 mb-lg-0">
                                <div className="small text-muted">Retailer</div>
                                <div>{retailer}</div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-6">
                            <div className="mb-3">
                                <div className="small text-muted">SKU</div>
                                <div>{sku}</div>
                            </div>
                            <div>
                                <div className="small text-muted">Period</div>
                                <div>{period}</div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-3 mt-1">
                        <div className="col-12 col-lg-6">
                            <div className="small text-muted">Retailer Weeks</div>
                            <div>{retailerWeeks}</div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="small text-muted">Total budget</div>
                            <div className="text-success fw-semibold fs-5">{totalBudget}</div>
                        </div>
                    </div>

                    <h3 className="h6 mb-3 mt-4">Parameters</h3>

                    <div className="row g-3">
                        <div className="col-6 col-md-4 col-lg">
                            <div className="small text-muted">Base price</div>
                            <div>NA</div>
                        </div>
                        <div className="col-6 col-md-4 col-lg">
                            <div className="small text-muted">Max discount</div>
                            <div>NA</div>
                        </div>
                        <div className="col-6 col-md-4 col-lg">
                            <div className="small text-muted">Trade promo</div>
                            <div>NA</div>
                        </div>
                        <div className="col-6 col-md-6 col-lg">
                            <div className="small text-muted">Retail media</div>
                            <div>NA</div>
                        </div>
                        <div className="col-6 col-md-6 col-lg">
                            <div className="small text-muted">Target margin</div>
                            <div>NA</div>
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default SimulationInputs;
